import { EventType } from "./internalTypes.js";
import { IS_DERIVED_CONSTRUCTOR } from "./derived.js";
import { SERIALIZE, rehydrate } from "./rehydrate.js";
import { statemachine } from "./statemachine.js";
import { ENVIRONMENT, MODE_DEFAULT, MODE_SSR, MODE_TEST, json } from "./utils.js";
import { Overmind } from "./Overmind.js";
import { createMutationOperator, createOperator } from "./operator.js";
import { branch, catchError, debounce, filter, fork, noop, parallel, pipe, throttle, tryCatch, wait, waitUntil, when } from "./operators.js";
import { createOvermindMock } from "./OvermindMock.js";
import { createOvermindSSR } from "./OvermindSSR.js";

//#region src/index.ts
const derived = (cb) => {
	cb[IS_DERIVED_CONSTRUCTOR] = true;
	return cb;
};
function createOvermind(config, options) {
	return new Overmind(config, options, { mode: MODE_DEFAULT });
}

//#endregion
export { ENVIRONMENT, EventType, MODE_DEFAULT, MODE_SSR, MODE_TEST, Overmind, SERIALIZE, branch, catchError, createMutationOperator, createOperator, createOvermind, createOvermindMock, createOvermindSSR, debounce, derived, filter, fork, json, noop, parallel, pipe, rehydrate, statemachine, throttle, tryCatch, wait, waitUntil, when };
//# sourceMappingURL=index.js.map